const DeleteModal = ({ del, setDel, confirmDelete, rental }) => {
    const delDisplay = () => {
        setDel(false);
    };

    return (
        <div className={del ? "container__delete__modal open__delete__modal" : "container__delete__modal"}>
            <div className='content__delete__modal'>
                <div>
                <p>Êtes-vous sûr de vouloir supprimer ?</p>
                <p>Notez que cette action est irréversible !!</p>
                <div>
                    <button className='btn__delete__rent' onClick={delDisplay}>Annuler</button>
                    <button className='btn__delete__rent' onClick={confirmDelete}><i className="fa-solid fa-trash"></i> Supprimer</button>
                </div>
                </div>
            </div>
        </div>
    );
};

export default DeleteModal